import { ApiError } from '../client';
import { getRejectDeliveryMockError, markDeliveryRejectedInMock } from './deliveryDetail';

// Mock of the reject WRITE: simulate latency, then either reject with an injected backend error
// (dev/test hook for the generic-error banner) or flip the delivery to rejected in the shared detail
// mock, so a follow-up fetchDeliveryDetailMock returns the new state. Idempotent.
export async function rejectDeliveryMock(id: string): Promise<void> {
  await new Promise((resolve) => setTimeout(resolve, 100));
  const injected = getRejectDeliveryMockError();
  if (injected !== null) {
    throw new ApiError(409, injected, { code: injected }, `reject failed: ${injected}`);
  }
  markDeliveryRejectedInMock(id);
}
